import React, { useEffect } from "react";
import { DataTable } from "../../Components/DataTable";
import { newPatientsColumns } from "./tableConfig";
import { useRvs } from "../../hooks/useRv";

export const NewPatientsTab: React.FC = () => {
  const { newPatientsRvs = [], isNewPatientsLoading, fetchNewPatients } = useRvs();

  useEffect(() => {
    fetchNewPatients();
  }, [fetchNewPatients]);

  return (
    <section className="mt-10 bg-white p-6 rounded-xl shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold capitalize">Νέοι Ασθενείς</h2>
      </div>
      <DataTable columns={newPatientsColumns} data={newPatientsRvs} loading={isNewPatientsLoading} />
    </section>
  );
};